// @flow
/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['layout', 'header', 'content'] }] */

import * as React from 'react';
import { connect } from 'react-redux';

import classNames from '@ta/common.classnames';
import { getDateInBrowserTimezone } from '@ta/social.dates';
import { globalize, localize } from '@ta/common.i18n';
import { Link } from '@ta/common.routing';
import type { ViewportCategory } from '@ta/common.state';
import { InteractionLogger } from '@ta/tracking.interactions';
import { getForumPostUrl } from '@ta/social.section-forum-post';

import layoutStyles from './ForumsListLayout.less';
import sectionStyles from './ForumsListSection.less';

type ExternalProps = {|
  post: any,
|};

type Props = {|
  ...ExternalProps,
  device: ViewportCategory,
  language: string,
|};

const ForumsListSection = ({ post, device, language }: Props) => {
  const isTopic = post.object.id === post.object.parentId;
  const topicUrl = getForumPostUrl(post.object, language);
  const forumUrl = post.object.forum.route.url;
  const publishedDate = getDateInBrowserTimezone(post.object.publishedDate);
  const topicTitle = isTopic
    ? post.object.topicTitle
    : localize('common_Re_topic_title', { '0': post.object.topicTitle });

  if (!post.object) {
    return null;
  }

  const tablet = (
    <InteractionLogger>
      {logFeedClick => (
        <React.Fragment>
          {publishedDate && (
            <span className={classNames(layoutStyles.cell, layoutStyles.date)}>
              {globalize.formatDate('date_medium', publishedDate)}
            </span>
          )}
          <span className={classNames(layoutStyles.cell, layoutStyles.type)}>
            {isTopic ? localize('mc_forum_topic_c8c') : localize('common_Reply')}
          </span>
          <span className={classNames(layoutStyles.cell, layoutStyles.forum)}>
            <Link
              key={`forum_${post.object.id}`}
              className="ui_link"
              href={forumUrl}
              title={post.object.forumName}
              onClick={e => logFeedClick(e, 'feedClick')}
            >
              {post.object.forumName}
            </Link>
          </span>
          <span className={classNames(layoutStyles.cell, layoutStyles.topic)}>
            <Link
              key={`topic_${post.object.id}`}
              className="ui_link"
              href={topicUrl}
              title={topicTitle}
              onClick={e => logFeedClick(e, 'feedClick')}
            >
              {topicTitle}
            </Link>
          </span>
        </React.Fragment>
      )}
    </InteractionLogger>
  );

  const mobile = (
    <div className={sectionStyles.cell}>
      {publishedDate && (
        <div className={sectionStyles.date_topic}>
          {globalize.formatDate('date_medium', publishedDate)}, {post.object.forumName}
        </div>
      )}
      <div className={sectionStyles.title}>
        <InteractionLogger>
          {logFeedClick => (
            <Link
              key={`topic_${post.object.id}`}
              className="ui_link"
              href={topicUrl}
              title={topicTitle}
              onClick={e => logFeedClick(e, 'feedClick')}
            >
              {topicTitle}
            </Link>
          )}
        </InteractionLogger>
      </div>
    </div>
  );

  return (
    <div className={layoutStyles.row}>
      {device !== 'MOBILE' ? (
        <React.Fragment>{tablet}</React.Fragment>
      ) : (
        <React.Fragment>{mobile}</React.Fragment>
      )}
    </div>
  );
};

export default connect<Props, ExternalProps, _, _, _, _>(redux => ({
  device: redux.meta.device.viewportCategory,
  language: redux.i18n.language,
}))(ForumsListSection);
